import { createI18n } from 'vue-i18n'
import ESP from "./ESP.js"//西班牙语
import PCP from "./PCP.js"//葡萄牙语
import NED from "./NED.js"//荷兰语
import PL from "./PL.js"//波兰语
import PCF from "./PCF.js"//法语
import Ita from "./Ita.js"//意大利语
import DE from "./DE.js"//德语
import zh_CN from "./zh-CN.js"
import en_US from "./en-US.js"


// 设置语言资源包
const messages = {
    'ESP':ESP,
    'PCP':PCP,
    'NED':NED,
    'PL':PL,
    'DE':DE,
    'PCF':PCF,
    'Ita':Ita,
    'ZN': zh_CN,
    'en_US': en_US,     
}

// 设置语言
let lang = localStorage.getItem('language')
localStorage.setItem('language',lang)
let i18n = createI18n({
   
    // fallbackLocale: localStorage.getItem('language') ,
    silentTranslationWarn: true,
    // 使用 composition API
    legacy:false,
    // 全局使用 t 函数
    globalInjection:true,
    locale:lang,
    messages
})

export default i18n



